import React, { useState } from 'react'
import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'

import { Button, Icon, IconButton } from '~components/internal'
import ContactBookSelector from '~components/internal/ContactBookSelector/cmv3'
import { type ContactView } from '~pages/ConstituentScreens/components/formData'
import { type ContactBook, type IdentityId, type TagData } from '~types'

import '../AddContactDialog.scss'

import AddContactFormControl, { type ContactFormData } from './AddContactFormControl'

interface AddContactDialogProps {
  open: boolean
  onClose: () => void
  onComplete?: (createdContact?: ContactView) => void
  contactBook?: ContactBook | null
  onContactBookChange?: (book: ContactBook) => void
  organizationIdentityIdList?: IdentityId[]
  availableTags?: TagData[]
  update?: boolean
  onUpdate?: (formData: ContactFormData) => Promise<void>
  initialData?: ContactFormData
  onDelete?: () => void
}

const AddContactDialog: React.FC<AddContactDialogProps> = ({
  open,
  onClose,
  onComplete,
  contactBook,
  onContactBookChange,
  organizationIdentityIdList,
  availableTags,
  update,
  onUpdate,
  initialData,
  onDelete,
}) => {
  const [isFormInvalid, setIsFormInvalid] = useState<boolean>(false)
  const [isSaved, setIsSaved] = useState<boolean>(false)

  return (
    <Dialog className='add-contact-dialog' open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle className='add-contact-dialog__title'>
        {update ? 'Update Contact' : 'Add Contact'}
        <IconButton size='small' onClick={onClose}>
          <Icon fontSize='small' name='close' />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {onContactBookChange && (
          <Box className='add-contact-dialog__contact-book'>
            <ContactBookSelector value={contactBook?.id} onSelect={onContactBookChange} fullWidth />
          </Box>
        )}
        <AddContactFormControl
          contactBook={contactBook}
          organizationIdentityIdList={organizationIdentityIdList}
          availableTags={availableTags}
          onClose={onClose}
          onComplete={onComplete}
          isSaved={isSaved}
          setIsSaved={setIsSaved}
          onFormValidChange={setIsFormInvalid}
          update={update}
          onUpdate={onUpdate}
          initialData={initialData}
        />
      </DialogContent>
      <DialogActions className='add-contact-dialog__actions'>
        {update && onDelete && (
          <Button color='error' onClick={onDelete}>
            Delete Contact
          </Button>
        )}
        <Box className='add-contact-dialog__standard-actions'>
          <Button variant='outlined' onClick={onClose}>
            Cancel
          </Button>
          <Button variant='contained' onClick={() => setIsSaved(true)} disabled={isFormInvalid}>
            {update ? 'Save' : 'Add'}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default AddContactDialog
